import { doc, setDoc } from 'firebase/firestore';
import { ISelectedEntitySettings } from '../../providers/settings/selectedEntitySettingsProvider';
import { userAsPromise } from '../../providers/userProvider';

/**
 * @description persists the users setting for selected entities
 * @param settings
 */
export const setSelectedEntitySettings = async (
  settings: ISelectedEntitySettings
): Promise<void> => {
  const user = await userAsPromise();

  return setDoc(
    doc(
      user.services.firestore,
      `userProfiles/${user.id}/settings/selectedEntities`
    ),
    settings,
    { merge: true }
  );
};
